var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_318",
    "data-name": "Group 318",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.686,
    height: 44.686,
    viewBox: "0 0 44.686 44.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 22.343,
    cy: 22.343,
    r: 22.343,
    fill: "rgba(255,255,255,0.07)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-android-7410544",
    transform: "translate(12.12 8.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M41.925,22.465a2,2,0,0,0-.957.252,1.68,1.68,0,0,0-.086-.225.58.58,0,0,0,.175-.413,7.293,7.293,0,0,0-1.719-4.708L40.4,16.2a.578.578,0,0,0-.856-.778l-1.022,1.127a7.289,7.289,0,0,0-9.589,0l-1.02-1.124a.578.578,0,1,0-.856.778l1.062,1.171A7.29,7.29,0,0,0,26.4,22.081a.571.571,0,0,0,.175.413,1.682,1.682,0,0,0-.086.225,2,2,0,0,0-.957-.252,2.028,2.028,0,0,0-2.025,2.025v8.68A2.028,2.028,0,0,0,25.533,35.2a2,2,0,0,0,.957-.252,1.733,1.733,0,0,0,1.647,1.216h.193v3.761a2.025,2.025,0,0,0,4.051,0V36.162h2.7v3.761a2.025,2.025,0,0,0,4.051,0V36.162h.193a1.731,1.731,0,0,0,1.647-1.216,2,2,0,0,0,.957.252,2.028,2.028,0,0,0,2.025-2.025v-8.68a2.028,2.028,0,0,0-2.025-2.025Zm-8.2-6.558A6.181,6.181,0,0,1,39.873,21.5H27.582a6.181,6.181,0,0,1,6.145-5.594Zm-8.2,18.131a.868.868,0,0,1-.868-.868v-8.68a.868.868,0,0,1,1.736,0v8.68A.868.868,0,0,1,25.53,34.039Zm5.69,5.883a.868.868,0,0,1-1.736,0V36.16H31.22Zm6.751,0a.868.868,0,1,1-1.736,0V36.16h1.736Zm1.929-5.5a.579.579,0,0,1-.579.579H28.134a.579.579,0,0,1-.579-.579V23.237a.579.579,0,0,1,.579-.579H39.321a.579.579,0,0,1,.579.579Zm2.893-1.254a.868.868,0,1,1-1.736,0v-8.68a.868.868,0,1,1,1.736,0Z",
    transform: "translate(-23.507 -14.75)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.b1cc8a34afd9b53ed682c659acae0905.svg";
export { ForwardRef as ReactComponent };